/*
 * @Date: 2022-07-25 10:37:51
 * @LastEditors: lizixuan 240514049@qq.com
 * @LastEditTime: 2022-07-28 11:11:36
 * @FilePath: \hw_game_mp_gamebrain_data\frontend\src\api\v1\message_api.js
 * @Description: 
 */
import api from "../api";

const api_type = 'v1'

export const SocketBind = params => { return api.post(api_type+`/message/bind`, params) }
export const SocketList = params => { return api.post(api_type+`/message/getList`, params) }
export const SocketSend = params => { return api.post(api_type+`/message/send`, params) }





// WEBPACK FOOTER //
// ./src/api/v1/message_api.js